import CatalogItem from "@components/Actions/CatalogItems/Base";
import Icon from "@components/Atoms/Icon";
import { useRouter } from "@core/Api/useRouter";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import { catalogDeleteConfirm } from "@ext/catalog/actions/propsEditor/components/catalogDeleteConfirm";
import { useDeleteCatalogFromSpace } from "@ext/catalog/actions/propsEditor/components/useDeleteCatalog";
import t from "@ext/localization/locale/translate";
import { ConfirmMenuItem } from "@ui-kit/ConfirmPopover";
import type { ReactNode } from "react";

const DeleteCatalogFromSpace = ({ children }: { children: ReactNode }) => {
	const router = useRouter();
	const name = useCatalogPropsStore((state) => state.data?.name);
	const deleteFromSpace = useDeleteCatalogFromSpace({ name, onDeleted: () => router.pushPath("/") });

	const label = (
		<>
			<Icon code="trash" />
			{t("catalog.delete.space.name")}
		</>
	);

	return (
		<CatalogItem
			renderLabel={(Item) =>
				children ? (
					<Item>{label}</Item>
				) : (
					<ConfirmMenuItem confirm={catalogDeleteConfirm("space")} onConfirm={deleteFromSpace} type="danger">
						{label}
					</ConfirmMenuItem>
				)
			}
		>
			{children}
		</CatalogItem>
	);
};

export default DeleteCatalogFromSpace;
